import { getIdToken } from './auth';

/**
 * Fetch wrapper that automatically attaches the Firebase ID token. All API
 * calls in the web app go through this — never raw fetch — so we get one
 * place to handle auth, errors, and (later) request IDs / telemetry.
 */
export async function apiFetch<T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const token = await getIdToken();
  const headers = new Headers(init.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  if (init.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');

  const res = await fetch(path, { ...init, headers });
  const text = await res.text();
  const body = text ? JSON.parse(text) : null;

  if (!res.ok) {
    const err = new ApiError(res.status, body?.error ?? 'request_failed', body);
    throw err;
  }
  return body as T;
}

export class ApiError extends Error {
  constructor(public status: number, public code: string, public body: unknown) {
    super(`api ${status}: ${code}`);
  }
}
